import { GET_MILESTONE, SET_LOADING_MILESTONE, SET_PAGINATION_MILESTONE } from '../constant';

const initialState = {
  milestone: [],
  loadingMilestone: false,
  milestonePagination: 0,
  totalMilestone: 0,
};

const milestoneReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_MILESTONE: {
      return {
        ...state,
        loadingMilestone: action?.payload,
      };
    }
    case SET_PAGINATION_MILESTONE: {
      return {
        ...state,
        milestonePagination: action?.payload,
      };
    }
    case GET_MILESTONE: {
      return {
        ...state,
        milestone: action?.payload?.data || [],
        totalMilestone: action?.payload?.total,
        loadingMilestone: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default milestoneReducer;
